export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const LOGOUT = 'LOGOUT';

export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR';

export const UPLOAD_IMAGE_REQUEST = 'UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'UPLOAD_IMAGE_ERROR';

export const FETCH_EMAILS_REQUEST = 'FETCH_EMAILS_REQUEST';
export const FETCH_EMAILS_SUCCESS = 'FETCH_EMAILS_SUCCESS';
export const FETCH_EMAILS_ERROR = 'FETCH_EMAILS_ERROR';

export const SEND_EMAIL_REQUEST = 'SEND_EMAIL_REQUEST';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_ERROR = 'SEND_EMAIL_ERROR';

export const SAVE_DRAFT_REQUEST = 'SAVE_DRAFT_REQUEST';
export const SAVE_DRAFT_SUCCESS = 'SAVE_DRAFT_SUCCES';
export const SAVE_DRAFT_ERROR = 'SAVE_DRAFT_ERROR';

export const UPDATE_DRAFT_REQUEST = 'UPDATE_DRAFT_REQUEST';
export const UPDATE_DRAFT_SUCCESS = 'UPDATE_DRAFT_SUCCESS';
export const UPDATE_DRAFT_ERROR = 'UPDATE_DRAFT_ERROR';

export const EMAIL_TRASH_REQUEST = 'EMAIL_TRASH_REQUEST';
export const EMAIL_TRASH_SUCCESS = 'EMAIL_TRASH_SUCCESS';
export const EMAIL_TRASH_ERROR = 'EMAIL_TRASH_ERROR';

export const EMAIL_UNTRASH_REQUEST = 'EMAIL_UNTRASH_REQUEST';
export const EMAIL_UNTRASH_SUCCESS = 'EMAIL_UNTRASH_SUCCESS';
export const EMAIL_UNTRASH_ERROR = 'EMAIL_UNTRASH_ERROR';

export const TOGGLE_EMAIL_PROP_REQUEST = 'TOGGLE_EMAIL_PROP_REQUEST';
export const TOGGLE_EMAIL_PROP_SUCCESS = 'TOGGLE_EMAIL_PROP_SUCCESS';
export const TOGGLE_EMAIL_PROP_ERROR = 'TOGGLE_EMAIL_PROP_ERROR';

export const DELETE_EMAIL_REQUEST = 'DELETE_EMAIL_REQUEST';
export const DELETE_EMAIL_SUCCESS = 'DELETE_EMAIL_SUCCESS';
export const DELETE_EMAIL_ERROR = 'DELETE_EMAIL_ERROR';
